<script setup lang="ts">
import { ref, reactive, computed } from 'vue'
import type { Component } from 'vue';
import Inquiry from '@/javascripts/utils/inquiry'
import useShindanInquiryValidation from '@/javascripts/composables/inquiry/shindan_validation';
import SectionTop from './shindan_slide_top.vue';
import Section1 from './shindan_slide_section1.vue';
import Section2 from './shindan_slide_section2.vue';
import Section3 from './shindan_slide_section3.vue';
import Section4 from './shindan_slide_section4.vue';
import Section5 from './shindan_slide_section5.vue';
import Section6 from './shindan_slide_section6.vue';
import Section7 from './shindan_slide_section7.vue';
import Section8 from './shindan_slide_section8.vue';

const currentSlideIndex = ref<number>(0);
const transitionName = ref<'next' | 'back'>('next');

const inquiry = reactive(new Inquiry);

const v$ = useShindanInquiryValidation(inquiry);

/** `next`イベントハンドラー */
const next = () => {
  transitionName.value = 'next';
  currentSlideIndex.value++;
}

/** `back`イベントハンドラー */
const back = () => {
  transitionName.value = 'back';
  currentSlideIndex.value--;
}

/** スライドコンポーネントリスト */
const slideComponents: Component[] = [
  SectionTop,
  Section1,
  Section2,
  Section3,
  Section4,
  Section5,
  Section6,
  Section7,
  Section8,
];

const currentSlideComponent = computed(() => slideComponents[currentSlideIndex.value]);
</script>

<template>
  <Transition
    :name="transitionName"
    mode="out-in"
  >
    <component
      :is="currentSlideComponent"
      :inquiry-validation="v$"
      :inquiry="inquiry"
      :current-slide-index="currentSlideIndex"
      @next="next"
      @back="back"
    />
  </Transition>
</template>
